import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import AwesomeIcon from "../AwesomeIcon";
var TextButton = function TextButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    icon = _ref.icon,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? "left" : _ref$iconPosition,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "sm" : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "primary" : _ref$color;
  var iconSize = size === "md" ? "lg" : "sm";
  var colorClasses = {
    primary: "text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300",
    grey: "text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300",
    danger: "text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300"
  };
  return /*#__PURE__*/React.createElement("button", {
    className: classNames("flex items-center gap-2 transition-colors duration-200", colorClasses[color], {
      "text-sm": size === "sm",
      "text-base": size === "md",
      "opacity-50 cursor-not-allowed": disabled
    }, className),
    onClick: onClick,
    disabled: disabled
  }, icon && iconPosition === "left" && /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: icon,
    size: iconSize
  }), children, icon && iconPosition === "right" && /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: icon,
    size: iconSize
  }));
};
export default TextButton;